import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { BottomHeaderConfig, MainHeaderConfig, TopHeaderConfig } from '@urbannex/storethemes';

export interface HeaderThemeState{
  mainHeaderConfigState:MainHeaderConfig;
  topHeaderConfigState:TopHeaderConfig;
  bottomHeaderConfigState:BottomHeaderConfig;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderThemeStateService extends ComponentStore<HeaderThemeState> {

  constructor() {
    super({mainHeaderConfigState:undefined,
      topHeaderConfigState:undefined,
      bottomHeaderConfigState:undefined})
   }

   init(mainHeaderConfigState:MainHeaderConfig,topHeaderConfigState:TopHeaderConfig,bottomHeaderConfigState:BottomHeaderConfig){
    this.updateMainState(mainHeaderConfigState);
    this.updateTopState(topHeaderConfigState);
    this.updateBottomState(bottomHeaderConfigState);
   }
   //updaters
   readonly updateMainState = this.updater((state:HeaderThemeState, mainHeaderConfigState:MainHeaderConfig) => {
    return {
      ...state,
      mainHeaderConfigState:mainHeaderConfigState
    }
   })
   readonly updateTopState = this.updater((state:HeaderThemeState, topHeaderConfigState:TopHeaderConfig) => {
    return {
      ...state,
      topHeaderConfigState:topHeaderConfigState
    }
   })
   readonly updateBottomState = this.updater((state:HeaderThemeState, bottomHeaderConfigState:BottomHeaderConfig) => {
    return {
      ...state,
      bottomHeaderConfigState:bottomHeaderConfigState
    }
   })
   //selector
   //effects
}
